import { useCallback, useState } from 'react';

const PAGE_SIZE = 6;

export interface SidebarPagination {
  visibleCount: (sectionKey: string) => number;
  revealMore: (sectionKey: string) => void;
}

/**
 * Per-section pagination for the sidebar (Layer 6 D56).
 *
 * Each section starts showing 6 items. `revealMore(key)` adds 6 more.
 * State is in-memory only — refresh resets to 6.
 *
 * Sprint agent-stages — keys are dynamic now (stage ids + 'noStage' +
 * 'archived') instead of the fixed recency-bucket union, so the record
 * is sparse and `visibleCount` supplies the default.
 */
export function useSidebarPagination(): SidebarPagination {
  const [counts, setCounts] = useState<Record<string, number>>({});

  const visibleCount = useCallback(
    (sectionKey: string) => counts[sectionKey] ?? PAGE_SIZE,
    [counts],
  );

  const revealMore = useCallback((sectionKey: string) => {
    setCounts((prev) => ({
      ...prev,
      [sectionKey]: (prev[sectionKey] ?? PAGE_SIZE) + PAGE_SIZE,
    }));
  }, []);

  return { visibleCount, revealMore };
}
